// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionEstabelecimento_sectionContainer__GLMHa{
    width: 100%;
    background: #F9FAFB;
    height: 356px;
}

.sectionEstabelecimento_sectionWrapper__bd3h3{
    height:85%;
    display: flex;
    flex-wrap: wrap;
    justify-content:center;
    align-items: center;
    gap:2rem;
}


.sectionEstabelecimento_sectionTextContainer__O8XJy{
    width: 350px;
    height: 197px;
    padding:40px;
    margin-top: 4rem;
    text-align: left;
}

.sectionEstabelecimento_sectionText__-CeRn h3{
    font-family: var(--goldplay-medium);
    color: #343A40;
    font-size: 1.8rem;
    font-weight: 200;
    line-height: 34px;
    align-self: flex-start;
}


.sectionEstabelecimento_sectionItemContainer__GDxmQ{
    width: 248px;
    height: 178px;
    display: grid;
    grid-template-columns: repeat(5,1fr);
    gap: 20px;
}

.sectionEstabelecimento_sectionItem__lJS5W{
    width: 110px;
    height: 110px;
    background: #F2F2F2;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.sectionEstabelecimento_sectionItem__lJS5W:hover{
    cursor: pointer;
    transition: 0.4s;
    border: 1px solid var(--secundary);
}

.sectionEstabelecimento_textEstabelecimento__XUZpu{
    font-family: var(--goldplay-regular);
    line-height: 12px;
    padding-top: 10px;
    font-size: 14px;
    color: #343A40;
    text-align: center;
    text-decoration: none;
}

.sectionEstabelecimento_textEstabelecimento__XUZpu :hover{
    color: #343A40;
    text-decoration: none;
}

.sectionEstabelecimento_sectionItem__lJS5W img{
    width: 2.75rem;
    height: 2.75rem;
}


@media only screen and (min-width:320px)  and (max-width:480px){}
@media only screen and (min-width:576px)  and (max-width:640px){}
@media only screen and (min-width:768px)  and (max-width:992px){}
@media only screen and (min-width:993px)  and (max-width:1024px){}

@media only screen and (min-width:1280px){
    .sectionEstabelecimento_sectionWrapper__bd3h3{
        max-width: 64.6%;
    }
}

@media only screen and (min-width:1366px){
    .sectionEstabelecimento_sectionWrapper__bd3h3{
        max-width: 68%;
    }
}


@media only screen and (min-width:1600px){
   .sectionEstabelecimento_sectionWrapper__bd3h3{
        min-width: 74%;
   }
}


@media only screen and (min-width:1920px){
   .sectionEstabelecimento_sectionWrapper__bd3h3{
        min-width: 78%;
   }

}

@media only screen and (min-width:2560px){    
    .sectionEstabelecimento_sectionWrapper__bd3h3{
        min-width: 82.8%;
    }

} 

@media only screen and (min-width:3840px){
    .sectionEstabelecimento_sectionWrapper__bd3h3{
        min-width: 90%;
    }
}`, "",{"version":3,"sources":["webpack://./src/object/Section/estabelecimento/sectionEstabelecimento.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,oCAAoC;IACpC,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;AAGA,gEAAgE;AAChE,gEAAgE;AAChE,gEAAgE;AAChE,iEAAiE;;AAEjE;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;;AAGA;GACG;QACK,cAAc;GACnB;AACH;;;AAGA;GACG;QACK,cAAc;GACnB;;AAEH;;AAEA;IACI;QACI,gBAAgB;IACpB;;AAEJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ","sourcesContent":[".sectionContainer{\n    width: 100%;\n    background: #F9FAFB;\n    height: 356px;\n}\n\n.sectionWrapper{\n    height:85%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content:center;\n    align-items: center;\n    gap:2rem;\n}\n\n\n.sectionTextContainer{\n    width: 350px;\n    height: 197px;\n    padding:40px;\n    margin-top: 4rem;\n    text-align: left;\n}\n\n.sectionText h3{\n    font-family: var(--goldplay-medium);\n    color: #343A40;\n    font-size: 1.8rem;\n    font-weight: 200;\n    line-height: 34px;\n    align-self: flex-start;\n}\n\n\n.sectionItemContainer{\n    width: 248px;\n    height: 178px;\n    display: grid;\n    grid-template-columns: repeat(5,1fr);\n    gap: 20px;\n}\n\n.sectionItem{\n    width: 110px;\n    height: 110px;\n    background: #F2F2F2;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.sectionItem:hover{\n    cursor: pointer;\n    transition: 0.4s;\n    border: 1px solid var(--secundary);\n}\n\n.textEstabelecimento{\n    font-family: var(--goldplay-regular);\n    line-height: 12px;\n    padding-top: 10px;\n    font-size: 14px;\n    color: #343A40;\n    text-align: center;\n    text-decoration: none;\n}\n\n.textEstabelecimento :hover{\n    color: #343A40;\n    text-decoration: none;\n}\n\n.sectionItem img{\n    width: 2.75rem;\n    height: 2.75rem;\n}\n\n\n@media only screen and (min-width:320px)  and (max-width:480px){}\n@media only screen and (min-width:576px)  and (max-width:640px){}\n@media only screen and (min-width:768px)  and (max-width:992px){}\n@media only screen and (min-width:993px)  and (max-width:1024px){}\n\n@media only screen and (min-width:1280px){\n    .sectionWrapper{\n        max-width: 64.6%;\n    }\n}\n\n@media only screen and (min-width:1366px){\n    .sectionWrapper{\n        max-width: 68%;\n    }\n}\n\n\n@media only screen and (min-width:1600px){\n   .sectionWrapper{\n        min-width: 74%;\n   }\n}\n\n\n@media only screen and (min-width:1920px){\n   .sectionWrapper{\n        min-width: 78%;\n   }\n\n}\n\n@media only screen and (min-width:2560px){    \n    .sectionWrapper{\n        min-width: 82.8%;\n    }\n\n} \n\n@media only screen and (min-width:3840px){\n    .sectionWrapper{\n        min-width: 90%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionContainer": `sectionEstabelecimento_sectionContainer__GLMHa`,
	"sectionWrapper": `sectionEstabelecimento_sectionWrapper__bd3h3`,
	"sectionTextContainer": `sectionEstabelecimento_sectionTextContainer__O8XJy`,
	"sectionText": `sectionEstabelecimento_sectionText__-CeRn`,
	"sectionItemContainer": `sectionEstabelecimento_sectionItemContainer__GDxmQ`,
	"sectionItem": `sectionEstabelecimento_sectionItem__lJS5W`,
	"textEstabelecimento": `sectionEstabelecimento_textEstabelecimento__XUZpu`
};
export default ___CSS_LOADER_EXPORT___;
